import { tWithKeyAttr as t } from "../../../i18nHelper";
import loginStyles from "../../../pages/login/login.module.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSendCodeWithoutLoginMutation } from "../../../services/api/auth.api";
import { useAppSelector } from "../../../services/hooks";
import { errorUserSelector } from "../../../services/selectors/auth.selectors";
import { useActions } from "../../../services/hooks/useActions";
import { useFormik } from "formik";
import { loginSMSValidationSchema } from "../../../utils/validation";

function LoginSmsForm() {
  const navigate = useNavigate();
  const { setPhone } = useActions();
  const loginError =
    useAppSelector(errorUserSelector) || t('MAIN_PAGE_TREATMENT_ERROR');

  const [sendCodeWithoutLogin, { isError, status }] =
    useSendCodeWithoutLoginMutation();


  const formik = useFormik({
    initialValues: {
      phone: "",
      roleId: "2",
      code: "0",
    },
    validationSchema: loginSMSValidationSchema,
    onSubmit: (values, { setSubmitting }) => {
      // Handle form submission
      setPhone(values.phone);
      sendCodeWithoutLogin(formik.values).then((response) => {
        if ("data" in response && response.data.success) {
          navigate("/enter_code");
        }
      });
      setSubmitting(false);
    },
  });


  return (
    <form onSubmit={formik.handleSubmit} className={loginStyles.login__form} data-testid="login-therapist-page">
      <p className={loginStyles.login__formText}>{t("SMS_WILL_BE_SENT")}</p>
      <label htmlFor="name" className={loginStyles.login__label}>
        {t("MY_MOBILE_NUMBER_LABEL")}
      </label>
      <input
        type="tel"
        className={`${loginStyles.login__input} ${loginStyles.login__input_type_phone} ${formik.errors.phone && loginStyles.login__input_invalid}`}
        name="phone"
        required={true}
        data-testid="phone-number"
        placeholder={t("MOBILE_NUMBER_PLACEHOLDER")}
        value={formik.values.phone}
        onChange={(e) => {
          // Allow only '+' and digits, max length 16 to cover E.164
          const sanitized = e.target.value.replace(/[^+\d]/g, "");
          if (/^\+?\d*$/.test(sanitized) && sanitized.length <= 16) {
            formik.setFieldValue("phone", sanitized);
          }
        }}
        onBlur={formik.handleBlur}
      />
     
      {formik.errors.phone && (
        <p
          className={`${loginStyles.login__invalid_message}`}
          data-testid="params-error-by-phone"
        >
          {t(formik.errors.phone)}
        </p>
      )}
      {isError && (
        <p
          className={`${loginStyles.login__invalid_message}`}
          data-testid="login-error-by-phone"
        >
          {loginError}
        </p>
      )}
      <button
        className={loginStyles.login__restorePasswordLink}
        type="submit"
        disabled={
          !formik.values.phone ||
          !formik.isValid ||
          formik.isSubmitting ||
          status === "pending"
        }
      >
        {/* לא קיבלת הודעה? שלח שוב */}
      </button>
      <button
        type="submit"
        disabled={
          !formik.values.phone ||
          !formik.isValid ||
          formik.isSubmitting ||
          status === "pending"
        }
        className={`button ${loginStyles.login__button} ${!formik.values.phone ||
          !formik.isValid ||
          formik.isSubmitting ||
          status === "pending"
          ? loginStyles.login__button_disabled
          : "hover"
          }`}
          data-testid="login-by-sms"
      >
        {status === "pending" ? t('ADD_TREATMENT_PLAN_BUTTON_SENDING') : t("LOG_IN")}
      </button>
    </form>
  );
}

export default LoginSmsForm;
